// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LMpf","left":"styles_left__1KZN5"};